import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'throttleit';

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}; // eslint-disable-next-line


var ScrollSensor = function (_React$Component) {
  inherits(ScrollSensor, _React$Component);

  function ScrollSensor(props) {
    classCallCheck(this, ScrollSensor);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.updateScrollPosition = function (e) {
      if (e.isTrusted) {
        _this.setState({
          scrollY: window.scrollY,
          scrollX: window.scrollX
        });
      }
    };

    _this.state = {
      mounted: false,
      scrollX: 0,
      scrollY: 0
    };
    _this.handleScroll = _this.props.throttleDelay > 100 ? throttle(_this.updateScrollPosition.bind(_this), _this.props.throttleDelay) : _this.updateScrollPosition.bind(_this);
    return _this;
  }

  ScrollSensor.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      mounted: true,
      scrollY: window.scrollY,
      scrollX: window.scrollX
    });
    document.addEventListener("scroll", this.handleScroll);
  };

  ScrollSensor.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener("scroll", this.handleScroll);
  };

  ScrollSensor.prototype.render = function render() {
    if (typeof this.props.children !== "function") {
      throw new Error("Expected ScrollSensor child to be a function");
    }

    return this.props.children(this.state.scrollX, this.state.scrollY, this.state.mounted);
  };

  return ScrollSensor;
}(React.Component);

ScrollSensor.defaultProps = {
  throttleDelay: 300
};
ScrollSensor.propTypes = {
  throttleDelay: PropTypes.number,
  children: PropTypes.func.isRequired
};
export default ScrollSensor;